<template>
  <UserFormPage mode="edit" />
</template>

<script>
import UserFormPage from './user-form-page.vue';

export default {
  name: 'newuseredit',
  components: { UserFormPage },
};
</script>
